module.exports = __webpack_public_path__ + "static/media/info.eed4d3f8.svg";